import "./index.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _Link = _interopRequireDefault(require("../Link"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Popover = _interopRequireDefault(require("../../Popover"));

var _component = require("../../_utils/component.js");

var _categoires = _interopRequireDefault(require("./categoires"));

var _tags = _interopRequireDefault(require("./tags"));

var _request = _interopRequireDefault(require("../../request"));

var _data = require("../data.js");

var _vueNormalizeComponent = _interopRequireDefault(require("../../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('header-templates'),
  components: {
    GDLink: _Link.default,
    Icon: _Icon.default,
    TemplateCategories: _categoires.default,
    TemplateTags: _tags.default,
    Popover: _Popover.default
  },
  mixins: [_component.componentMixin],

  data() {
    return {
      tabKey: 1,
      visible: false,
      industries: _data.industries,
      styles: [],
      business: [],
      categories: []
    };
  },

  mounted() {
    this.getCategories();
    this.getStyles();
    this.getBusiness();
  },

  methods: {
    getCategories() {
      var _this = this;

      return (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _ref, categories;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _request.default.get('/api/categories', {
                  params: {
                    parent_id: 0,
                    level: 2,
                    with_children: 1
                  },
                  cache: {
                    type: 'localCache',
                    revalidate: true
                  }
                });

              case 2:
                _ref = _context.sent;
                categories = _ref.data;
                _this.categories = categories;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    getStyles() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _request.default.get('/api/attributes', {
                  params: {
                    type: 'style'
                  },
                  cache: {
                    type: 'localCache',
                    revalidate: true
                  }
                });

              case 2:
                res = _context2.sent;
                _this2.styles = res.data;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    getBusiness() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _request.default.get('/api/tags?groups=64', {
                  cache: {
                    type: 'localCache',
                    revalidate: true
                  }
                });

              case 2:
                res = _context3.sent;
                _this3.business = res.data.map(function (b) {
                  return {
                    id: b.id,
                    name: b.name
                  };
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    changeKey(key) {
      this.tabKey = key;
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("Popover", {
    attrs: {
      modifiers: {
        offset: {
          offset: "185px, 10px"
        },
        preventOverflow: {
          boundariesElement: "window"
        },
        flip: {
          enabled: false
        }
      },
      lazy: false,
      visible: _vm.visible,
      "popover-class": _vm.bem("popover")
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      },
      "after-leave": function afterLeave($event) {
        return _vm.changeKey(1);
      },
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c("div", {
    class: _vm.bem(),
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("div", {
    class: _vm.bem("tabs")
  }, [_c("div", {
    class: _vm.bem("tab", {
      active: _vm.tabKey === 1
    }),
    on: {
      mouseenter: function mouseenter($event) {
        return _vm.changeKey(1);
      }
    }
  }, [_c("div", [_c("h3", [_vm._v("分类")]), _vm._v(" "), _c("div", {
    class: _vm.bem("desc")
  }, [_vm._v("手机海报 社交媒体")])])]), _vm._v(" "), _c("div", {
    class: _vm.bem("tab", {
      active: _vm.tabKey === 2
    }),
    on: {
      mouseenter: function mouseenter($event) {
        return _vm.changeKey(2);
      }
    }
  }, [_c("div", [_c("h3", [_vm._v("行业")]), _vm._v(" "), _c("div", {
    class: _vm.bem("desc")
  }, [_vm._v("教育培训 餐饮美食")])])]), _vm._v(" "), _c("div", {
    class: _vm.bem("tab", {
      active: _vm.tabKey === 3
    }),
    on: {
      mouseenter: function mouseenter($event) {
        return _vm.changeKey(3);
      }
    }
  }, [_c("div", [_c("h3", [_vm._v("风格")]), _vm._v(" "), _c("div", {
    class: _vm.bem("desc")
  }, [_vm._v("简约 商务 手绘")])])])]), _vm._v(" "), _c("div", {
    class: _vm.bem("content")
  }, [_vm.tabKey === 1 ? _c("TemplateCategories", {
    attrs: {
      categories: _vm.categories
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }) : _vm.tabKey === 2 ? _c("TemplateTags", {
    attrs: {
      list: _vm.business,
      filter: "tid"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }) : _vm.tabKey === 3 ? _c("TemplateTags", {
    attrs: {
      list: _vm.styles,
      filter: "q"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c("div", {
    class: _vm.bem("all-template")
  }, [_c("GDLink", {
    attrs: {
      url: {
        path: "templates"
      }
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("\n                    查看所有模板\n                    "), _c("Icon", {
    attrs: {
      name: "arrow-right"
    }
  })], 1)], 1)], 1)])], 2);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;